import { Query, toQuery } from "../helpers/general";

export const apiConfig = {
  offers: {
    set_order: () => "specials/orders",
    all: (query: Query) => `specials/all${toQuery({ ...query })}`,
    organize: (query: Query) => `specials/organize${toQuery({ ...query })}`,
  },
  events: {
    set_order: () => "events/orders",
    all: (query: Query) => `events/ours${toQuery({ ...query })}`,
    markBookingsPaid: (eventId: string) =>
      `events/${eventId}/mark-bookings-paid`,
  },
  users: {
    get: (id: string) => `users/${id}`,
    list: (query: string) => `users/filter?${query}`,
    drivers: {
      complete_profile: (driverId: string) =>
        `users/${driverId}/driver/complete-profile`,
      upload_docs: (driverId: string) =>
        `users/driver-profile/${driverId}/upload-doc`,
      set_expiration_date: (driverId: string) =>
        `users/driver-profile/${driverId}/set-expiration-date`,
      driver_sessions: (query: Query) =>
        `users/driver-sessions${toQuery(query)}`,
      sessions: (userId: string, query: Query) =>
        `users/sessions/${userId}${toQuery({ ...query })}`,
    },
    rides: (id: string, query: Query) =>
      `users/${id}/on-going-rides${toQuery({ ...query })}`,
    unpaidBonus: (id: string) => `users/rides/rides-bonus-status/${id}`,
    points: (id: string, query: Query) =>
      `users/points-history/${id}${toQuery({ ...query })}`,

    placeManagers: {
      list: (query?: Query) => `users/place-manager${toQuery({ ...query })}`,
    },
  },
  places: {
    get: (placeId: string) => `places/${placeId}`,
  },
  payment: {
    pendingAmount: (placeId: string) =>
      `payment/place/${placeId}/pending-amount`,
    pendingAmountBreakdown: (placeId: string) =>
      `payment/place/${placeId}/pending-amount-breakdown`,
  },
  rides: {
    all: (query: Query) => `rides${toQuery({ ...query })}`,
    chats: (rideId: String) => `rides/${rideId}/conversations`,
    get: (rideId: String) => `rides/${rideId}`,
    valid_ride: (rideId: String) => `rides/${rideId}/mark-valid`,
    invalid_ride: (rideId: String) => `rides/${rideId}/mark-invalid`,
    update_ride: (rideId: String) => `taxi/update-ride/${rideId}`,
    update_internal_comments: (rideId: String) =>
      `rides/${rideId}/internal-comments`,
    getByIds: (ids: string) => `rides/many?ids=${ids}`,
  },
  transactions: {
    all: (query: Query) => `transactions${toQuery({ ...query })}`,
    topup: (userId: string) => `transactions/balance/${userId}/topup`,
    ride_bonus: (userId: string) => `transactions/${userId}/rides-bonus`,
    ride_discount: (userId: string) => `transactions/${userId}/rides-discount`,
    ride_balance: (userId: string) =>
      `transactions/${userId}/rides-user-balance`,
    me: (query?: Query) => `/transactions/me${toQuery(query || {})}`,
  },
  taxiCoupon: {
    get_usage: (couponId: string, query: Query) =>
      `taxi-coupons/${couponId}/usage${toQuery({ ...query })}`,
  },
  taxiStatistics: {
    all: (query: Query) => `rides/statistics${toQuery({ ...query })}`,
    topDrivers: (query: Query) =>
      `rides/statistics/top-performing-drivers${toQuery({ ...query })}`,
  },
  userStatistics: {
    all: (query: Query) => `users/statistics${toQuery({ ...query })}`,
    topUsers: (query: Query) =>
      `users/statistics/top-performing-users${toQuery({ ...query })}`,
  },
  reviews: {
    user_rides_reviews: (userId: string, query: Query) =>
      `rides-reviews/${userId}${toQuery({ ...query })}`,
    user_booking_reviews: (userId: string, query: Query) =>
      `users/reviews/${userId}${toQuery({ ...query })}`,
    delete: (reviewId: string) => `reviews/${reviewId}`,
    deleteRideReview: (reviewId: string) => `rides-reviews/${reviewId}`,
  },
  partnair: {
    all: (query: Query) => `partners${toQuery({ ...query })}`,
    request: (query: Query) => `partners/requests${toQuery({ ...query })}`,
  },
};
